import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import SimplePagination from "./SimplePagination";
import { LangContext } from "../LangContext.jsx";

class VenversProviders extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            providers: [],
            search:'',
            page: 1,
            total: 0,
            maxRecords: props.top,
            syncFilter: '',
            syncStatusSummary: {
                exists: 0,
                missing: 0,
            },
            syncingProviderId: null,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSwitch = this.handleSwitch.bind(this);
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
        this.handleSyncFilter = this.handleSyncFilter.bind(this);
        this.syncProvider = this.syncProvider.bind(this);
    }

    async getProviders(){
        var url = '/api/venvers/providers/list';
        const query = new URLSearchParams();
        query.append('page', this.state.page)
        query.append('internal', this.props.internal)
        query.append('maxRecords', this.state.maxRecords)
        if(this.state.search!=''){
            query.append('search', this.state.search)
        }
        if(this.state.syncFilter!==''){
            query.append('sync_status', this.state.syncFilter)
        }
        const qs = query.toString();
        const res = await axios.get(url+`?${qs}`);
        const data = res.data.data;
        this.setState({
            providers: data,
            total: res.data.total,
            syncStatusSummary: {
                exists: res.data.sync_true ?? 0,
                missing: res.data.sync_false ?? 0,
            },
        });
    }

    handleChange(e){
        this.setState({providers: [], search: e.target.value, page: 1}, function () {
            this.getProviders();
        });
    }

    handleSwitch(i, id){
        let items = [...this.state.providers];
        let item = {...items[i]};
        item.active = (item.active)?false:true;
        items[i] = item;

        this.setState({providers: items}, function () {
            this.updateActive(id, items);
        });
    }

    updateCurrentPage(page){
        this.setState({page: page}, function () {
            this.getProviders();
        });
    }

    handleSyncFilter(syncFilter){
        this.setState({syncFilter, page: 1}, function () {
            this.getProviders();
        });
    }

    async updateActive(id){
        var url = '/api/providers/update_active/'+id;
        const res = await axios.get(url);
        const data = res.data;
    }

    async syncProvider(provider){
        const providerId = provider.person_id ?? provider.persona?.id;
        const rfc = provider.persona?.rfc;

        if (!rfc) {
            swal.fire({
                text: 'No se encontro RFC para sincronizar este proveedor.',
                icon: 'error',
                buttonsStyling: false,
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
            return;
        }

        this.setState({ syncingProviderId: providerId });

        try {
            const response = await axios.post(`/api/venvers/providers/${encodeURIComponent(rfc)}/sync`);
            swal.fire({
                text: response.data.message || 'Proveedor sincronizado con Venvers.',
                icon: 'success',
                buttonsStyling: false,
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
            await this.getProviders();
        } catch (error) {
            const message = error.response?.data?.message || 'No se pudo sincronizar el proveedor con Venvers.';
            swal.fire({
                text: message,
                icon: 'error',
                buttonsStyling: false,
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
        } finally {
            this.setState({ syncingProviderId: null });
        }
    }

  async componentDidMount() { 
    await this.getProviders();
  }

  render() {
    const { lang } = this.context; 
    const exportQuery = new URLSearchParams();
    if (this.state.search !== '') {
        exportQuery.append('search', this.state.search);
    }
    if (this.state.syncFilter !== '') {
        exportQuery.append('sync_status', this.state.syncFilter);
    }
    const exportUrl = `/venvers_providers/export${exportQuery.toString() ? `?${exportQuery.toString()}` : ''}`;

    return (
    <>
        <div className="card card-custom gutter-b my-5">
            <div className="card-header border-0 pt-6">
                <h3 className="card-title align-items-start flex-column">
                    <span className="card-label font-weight-bolder font-size-h4 text-dark-75">

                        Venvers
                    </span>
                    
                    <span className="text-muted mt-3 font-weight-bold font-size-lg">{this.state.total} {lang.get('messages.invitados_en_total')}</span>
                    <span className="mt-3 font-weight-bold font-size-sm d-block">
                        <button
                            type="button"
                            className={`badge mr-2 border-0 ${this.state.syncFilter === 'true' ? 'badge-success' : 'badge-light-success'}`}
                            onClick={() => this.handleSyncFilter(this.state.syncFilter === 'true' ? '' : 'true')}
                        >
                            Existe en Venvers: {this.state.syncStatusSummary.exists}
                        </button>
                        <button
                            type="button"
                            className={`badge border-0 ${this.state.syncFilter === 'false' ? 'badge-secondary' : 'badge-light-secondary'}`}
                            onClick={() => this.handleSyncFilter(this.state.syncFilter === 'false' ? '' : 'false')}
                        >
                            No existe en Venvers: {this.state.syncStatusSummary.missing}
                        </button>
                    </span>
                </h3>
                <div className="card-toolbar">
                    <div className="d-flex align-items-center">
                        <a href={exportUrl} className="btn btn-light-primary font-weight-bolder mr-3">
                            <i className="flaticon2-download"></i>
                            Exportar Excel
                        </a>
                        <div className="input-icon">
                            <input
                                style={{width:'400px'}}
                                onChange={this.handleChange}
                                name="search"
                                type="text"
                                className="form-control"
                                placeholder={lang.get('messages.buscar_invitado')} />
                            <span>
                                <i className="flaticon2-search-1 text-primary icon-md"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-body pt-5">
            <table className="table table-borderless table-vertical-center mb-0">
                <tbody> 
                {this.state.providers.map((o, i) => {
                    const persona = o.persona || {};
                    const providerId = o.person_id ?? persona.id;
                    const syncStatus = o.sync_status === true || o.sync_status === 1 || o.sync_status === '1';
                    const isSyncing = this.state.syncingProviderId === providerId;
                    const fiscalName = persona.fiscal_name || 'Proveedor sin datos';
                    const identity = persona.identity || 'RFC';
                    const rfc = persona.rfc || 'Sin RFC';
                    const personType = persona.person_type || 'Sin tipo';
                    const regimenId = persona.regimen_id;
                    const regimenName = persona.regimen_descrption;
                    const regimenText = regimenId || regimenName
                        ? 'Regimen fiscal: ' + (regimenId || 'Sin numero') + (regimenName ? ' - ' + regimenName : '')
                        : 'Regimen fiscal: Sin regimen';
                    const ownerEmail = persona.owner_email || 'Sin correo de owner';
                    const venversResult = o.venvers_result || 'Pendiente sincronizacion GDA';
                    const venversResultDate = o.venvers_result_date || o.latest_venvers_log?.created_at || 'Sin fecha de respuesta';

                    return (
                        <tr key={i}>
                        <td className="pl-0 py-5" style={{width: '1%'}}>
                            <div className="symbol symbol-40">
                                <div className={"symbol-label text-white font-weight-bolder bg-primary "  }>
                                {fiscalName.charAt(0).toUpperCase()}
                                </div>
                            </div>
                        </td>
                        <td className="text-left">
                        { this.props.internal == 1 &&
                            <a href={"/providers/"+providerId + "/internal"}>
                                <div className={"text-dark-75 font-weight-bolder mb-1 font-size-lg "  }>
                                     {fiscalName} <span className="text-muted font-weight-normal"> {identity}: {rfc}  </span>
                                </div>
                                <span className="text-muted">{lang.get('messages.tipo')}: {personType} { o.internal_company_identifier ?
                                    <>
                                        | No. {lang.get('messages.interno')}: {o.internal_company_identifier.internal_id } 
                                    </>
                                        :
                                        null
                                    }</span>
                                <span className="text-muted d-block">{regimenText}</span>
                                <span className="text-muted d-block">Email owner: {ownerEmail}</span>
                            </a>
                        }
                        { this.props.internal == 0 &&
                            <a href={"/providers/"+providerId}>
                                <div className={"text-dark-75 font-weight-bolder mb-1 font-size-lg "}>
                                    {fiscalName} <span className="text-muted font-weight-normal">{identity}: {rfc} </span>
                                </div>
                                <span className="text-muted">{lang.get('messages.tipo')}: {personType} { o.internal_company_identifier ?
                                    <>
                                        | No. {lang.get('messages.interno')}: {o.internal_company_identifier.internal_id } 
                                    </>
                                        :
                                        null
                                    }</span>
                                <span className="text-muted d-block">{regimenText}</span>
                                <span className="text-muted d-block">Email owner: {ownerEmail}</span>
                            </a>
                        }
                        </td>
                        <td className="text-left" style={{width: '1%'}}>
                            {syncStatus ? (
                                <span className="badge badge-success">Existe en Venvers</span>
                            ) : (
                                <span className="badge badge-secondary">No existe en Venvers</span>
                            )}
                            <span className="text-muted d-block mt-2" style={{minWidth: '260px', whiteSpace: 'normal'}}>
                                Resultado API: {venversResult}
                            </span>
                            <span className="text-muted d-block mt-1" style={{minWidth: '260px', whiteSpace: 'normal'}}>
                                Fecha respuesta API: {venversResultDate}
                            </span>
                        </td>
                        <td className="text-right">
                            <button
                                type="button"
                                className="btn btn-light-primary btn-sm mr-2"
                                disabled={isSyncing}
                                onClick={() => this.syncProvider(o)}
                                title="Sincronizar con Venvers"
                            >
                                {isSyncing ? 'Sincronizando...' : 'Sincronizar con Venvers'}
                            </button>
                        { this.props.internal == 1 &&
                            <a href={"/providers/"+providerId + "/internal"}>
                            <button className="btn btn-icon btn-light btn-xs">
                                <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                            </button>
                        </a>
                        }
                        { this.props.internal == 0 &&
                            <a href={"/providers/"+providerId}>
                            <button className="btn btn-icon btn-light btn-xs">
                                <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                            </button>
                        </a>
                        }
                        </td>
                    </tr>
                )})}
                </tbody>
                </table>
            </div>
            {this.state.total > this.state.maxRecords &&
                <SimplePagination
                updateCurrentPage={this.updateCurrentPage}
                currentPage={this.state.page}
                totalFiles={this.state.total}
                split={this.state.maxRecords} />
            }
        </div>
        </>
    );
    }
}

export default VenversProviders;
